// extracted by mini-css-extract-plugin
export default {"wrapper":"MsANxrUG1xg_p53SA0OQ","item":"oRymzvbnxrrtwCgZstLO"};